import React from 'react';
import AccessTime from '@mui/icons-material/AccessTime';
import AttachMoney from '@mui/icons-material/AttachMoney';
import CheckCircle from '@mui/icons-material/CheckCircle';
import EmojiEvents from '@mui/icons-material/EmojiEvents';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import School from '@mui/icons-material/School';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import differenceInCalendarMonths from 'date-fns/differenceInCalendarDays';
import CourseParameter from './courseCard/CourseParameter';
import NonEligibilityCriteriaAccordian from './StudentEligibilityComponents/NonEligibilityCriteriaAccordian';
import IntakeChip from './IntakeChip';
export var CourseCardCustomClickMapper;
(function (CourseCardCustomClickMapper) {
    CourseCardCustomClickMapper["VIEW_COURSE_DETAILS"] = "VIEW_COURSE_DETAILS";
})(CourseCardCustomClickMapper || (CourseCardCustomClickMapper = {}));
// card where we need to add report button
var CourseCard = function (_a) {
    var data = _a.data, _b = _a.renderCta, renderCta = _b === void 0 ? '' : _b, _c = _a.renderFooterCta, renderFooterCta = _c === void 0 ? '' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, nonEligibilityCriteriaCardProp = _a.nonEligibilityCriteriaCardProp, customClicksMapper = _a.customClicksMapper;
    var tuitionFeeOverallInr = data.tuitionFeeOverallInr, tuitionFeePerYear = data.tuitionFeePerYear, tuitionFeePerYearInr = data.tuitionFeePerYearInr, tuitionFeeOverall = data.tuitionFeeOverall, tuitionFeeCurrencyCode = data.tuitionFeeCurrencyCode, tuitionFee = data.tuitionFee, currency = data.currency, intakes = data.intakes, courseUrl = data.courseUrl, universityName = data.universityName, collegeName = data.collegeName, courseName = data.courseName, cityName = data.cityName, countryName = data.countryName, updatedAt = data.updatedAt, rank = data.rank, rankingProvider = data.rankingProvider, applicationFee = data.applicationFee, duration = data.duration;
    var isPerYearDataPresent = (data === null || data === void 0 ? void 0 : data.tuitionFeePerYearInr) && (data === null || data === void 0 ? void 0 : data.tuitionFeePerYear);
    var getTutionFeeTooltipDisplayValue = function () {
        var dataType = [undefined, null, '', 0];
        if (!dataType.includes(tuitionFeePerYearInr) && !dataType.includes(tuitionFeePerYear)) {
            return "INR ".concat(tuitionFeePerYearInr === null || tuitionFeePerYearInr === void 0 ? void 0 : tuitionFeePerYearInr.toLocaleString('en-IN'));
        }
        else if (!dataType.includes(tuitionFeeOverallInr)) {
            return "INR ".concat(tuitionFeeOverallInr === null || tuitionFeeOverallInr === void 0 ? void 0 : tuitionFeeOverallInr.toLocaleString('en-IN'));
        }
        return 'N/A';
    };
    var getTutionfee = function () {
        var dataType = [undefined, null, '', 0];
        if (!dataType.includes(tuitionFeePerYear) && !dataType.includes(tuitionFeePerYearInr)) {
            return "".concat(tuitionFeeCurrencyCode, " ").concat(tuitionFeePerYear);
        }
        else if (!dataType.includes(tuitionFeeOverall) && !dataType.includes(tuitionFeeCurrencyCode)) {
            return "".concat(tuitionFeeCurrencyCode, " ").concat(tuitionFeeOverall);
        }
        else if (!dataType.includes(tuitionFee) && !dataType.includes(currency)) {
            return "".concat(tuitionFee, " ").concat(currency);
        }
        return 'N/A';
    };
    var courseParameters = [
        {
            icon: React.createElement(AttachMoney, { className: "lfc-text-primary-300" }),
            value: applicationFee ? "".concat(tuitionFeeCurrencyCode || '', " ").concat(applicationFee || '-') : 'N/A',
            title: 'Application Fee'
        },
        {
            icon: React.createElement(AttachMoney, { className: "lfc-text-primary-300" }),
            title: isPerYearDataPresent ? '1st year Tuition Fee INR' : 'Tuition Fee',
            value: getTutionfee(),
            infoText: getTutionFeeTooltipDisplayValue()
        },
        {
            icon: React.createElement(AccessTime, { className: "lfc-text-primary-300" }),
            value: "".concat(duration, " Months"),
            title: 'Duration'
        },
        {
            icon: React.createElement(EmojiEvents, { className: "lfc-text-primary-300" }),
            value: "".concat(rank, " ").concat(rankingProvider ? "(".concat(rankingProvider, ")") : '', " "),
            title: 'College rank'
        }
    ];
    var groupedIntakes = (Array.isArray(intakes) &&
        (intakes === null || intakes === void 0 ? void 0 : intakes.reduce(function (acc, item) {
            if (acc[item.status]) {
                acc[item.status].push(item);
            }
            else {
                acc[item.status] = [item];
            }
            return acc;
        }, {}))) ||
        {};
    var handleViewCourse = function () {
        var _a;
        (_a = customClicksMapper === null || customClicksMapper === void 0 ? void 0 : customClicksMapper[CourseCardCustomClickMapper === null || CourseCardCustomClickMapper === void 0 ? void 0 : CourseCardCustomClickMapper.VIEW_COURSE_DETAILS]) === null || _a === void 0 ? void 0 : _a.call(customClicksMapper);
        window.open(courseUrl, '_blank', 'noopener');
    };
    var dateDiff = function (date) {
        var updatedDate = new Date(date);
        var today = new Date();
        var daysDiff = differenceInCalendarMonths(today, updatedDate);
        return daysDiff < 30 * 6 ? "".concat(daysDiff, " days ago") : 'more than 6 months ago';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "lfc-relative lfc-flex lfc-flex-wrap lfc-flex-col lfc-bg-white lfc-rounded-lg lfc-shadow lfc-border lfc-w-96/100 lfc-mb-4 lfc-m-auto ".concat(className) },
            (data === null || data === void 0 ? void 0 : data.gbOfferRate) === 'PREFERRED_INSTITUTE' && (React.createElement("p", { className: "lfc-absolute -lfc-top-2 -lfc-left-2 lfc-p-1 lfc-rounded-md lfc-bg-success-100  lfc-text-success-700 lfc-mr-1 lfc-flex lfc-items-center lfc-text-xs lfc-w-fit" },
                React.createElement("span", null,
                    React.createElement(TaskAltIcon, { className: "lfc-text-success-700 lfc-h-2 lfc-w-2 lfc-mr-2", sx: { fontSize: '18px !important' } })),
                "High Offer Chances")),
            React.createElement("div", { className: "lfc-flex lfc-w-full lfc-justify-between lfc-p-4" },
                React.createElement("div", { className: "lfc-text-left" },
                    React.createElement("span", { className: "lfc-flex hover:lfc-underline hover:lfc-cursor-pointer lfc-text-[#1B1D6A] lfc-text-base lfc-font-medium lfc-mb-2", onClick: handleViewCourse }, courseName),
                    React.createElement("span", { className: "lfc-flex lfc-text-sm lfc-text-gray-800 lfc-font-medium" },
                        React.createElement(School, { sx: { color: '#BDBDBD', fontSize: '20px' }, className: "lfc-mr-2" }),
                        universityName || collegeName,
                        cityName && (React.createElement(React.Fragment, null,
                            React.createElement(LocationOnOutlined, { sx: { color: '#BDBDBD', fontSize: '20px' }, className: "lfc-ml-2" }),
                            React.createElement("span", null, cityName))),
                        countryName && React.createElement("span", null,
                            ",\u00A0",
                            countryName))),
                renderFooterCta),
            nonEligibilityCriteriaCardProp && (React.createElement(NonEligibilityCriteriaAccordian, { nonEligibilityProp: (nonEligibilityCriteriaCardProp === null || nonEligibilityCriteriaCardProp === void 0 ? void 0 : nonEligibilityCriteriaCardProp.nonEligibilityProp) || [], toggleAccordion: nonEligibilityCriteriaCardProp === null || nonEligibilityCriteriaCardProp === void 0 ? void 0 : nonEligibilityCriteriaCardProp.toggleAccordion })),
            React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-rounded-md lfc-p-4" }, courseParameters.map(function (item, index) {
                return React.createElement(CourseParameter, { key: index, item: item });
            })),
            React.createElement("span", { className: "lfc-mx-4" },
                React.createElement(Divider, null)),
            (intakes === null || intakes === void 0 ? void 0 : intakes.length) > 0 && (React.createElement("div", { className: "lfc-flex  lfc-flex-col lfc-justify-center lfc-rounded lfc-p-4 lfc-pt-0 lfc-text-sm lfc-text-[#4A4A4A] lfc-mt-4" },
                React.createElement("p", { className: "lfc-mx-2 lfc-text-xs lfc-text-gray-700 lfc-block" }, " Intake Status:"),
                React.createElement("div", { className: "lfc-flex lfc-items-center" }, Object.keys(groupedIntakes).map(function (groupKey) { return (React.createElement(IntakeChip, { groupKey: groupKey, value: groupedIntakes[groupKey], key: groupKey, showInfo: groupKey === 'OPEN' })); })))),
            React.createElement("div", { className: "lfc-flex lfc-flex-row lfc-justify-between lfc-text-sm lfc-items-center lfc-w-full lfc-p-4 lfc-py-2" },
                React.createElement("div", null, updatedAt && (React.createElement("div", { className: "lfc-text-gray-700 lfc-flex lfc-items-center lfc-text-xs" },
                    React.createElement(CheckCircle, { sx: { color: '#25B94E', fontSize: '1.25rem' }, className: "lfc-mr-1" }),
                    "Updated\u00A0 ",
                    dateDiff(updatedAt)))),
                React.createElement("div", { className: "lfc-flex lfc-items-center" },
                    React.createElement("div", { className: "lfc-flex lfc-gap-2 lfc-items-center" },
                        React.createElement(Button, { variant: "outlined", className: "lfc-h-9", sx: { textTransform: 'none', minWidth: 'max-content' }, onClick: handleViewCourse }, "View Course Details"),
                        renderCta))))));
};
export default CourseCard;
//# sourceMappingURL=CourseCard.js.map